import LoginComponent from '../components/LoginComponent.vue';
import RegisterComponent from '../components/RegisterComponent.vue';
import LogoutButton from '../components/LogoutButton.vue';
import DashboardComponent from '../components/DashboardComponent.vue';
import LearnerDashboard from '../components/learner/LearnerDashboard.vue';
import CoursesTable from '../components/CoursesTable.vue';
import AddCourse from '../components/AddCourse.vue';
import EditCourse from '@/components/EditCourse.vue';
import MyCourses from '../components/learner/MyCourses.vue';
import MyProgress from '../components/learner/MyProgress.vue';
import MyBadges from '../components/learner/MyBadges.vue';
import CourseCatalog from '../components/learner/CourseCatalog.vue';
import ViewCourse from '../components/learner/ViewCourse.vue'; 
import CoursePage from '../components/learner/CoursePage.vue'; 
import AdminUsers from '../components/Admin/AdminUsers.vue'; 
import CreateUser from '../components/Admin/CreateUser.vue'; 
import UserGroups from '../components/Admin/UserGroups.vue'; 
import CreateGroup from '@/components/Admin/CreateGroup.vue'; 
import ViewGroup from '@/components/Admin/ViewGroup.vue';
import EditGroup from '@/components/Admin/EditGroup.vue';
import EditUser from '@/components/Admin/EditUser.vue';
import ViewUser from '@/components/Admin/ViewUser.vue';
import ViewBranch from '@/components/Admin/ViewBranch.vue';
import AdminBranches from '@/components/Admin/AdminBranches.vue';
import CreateBranch from '@/components/Admin/CreateBranch.vue';
import EditBranch from '@/components/Admin/EditBranch.vue';
import UserCertificates from '@/components/learner/UserCertificates.vue';
import MyProfile from '@/components/MyProfile.vue';
import AllUsersReports from '@/components/Reports/AllUsersReports.vue';
import UserReport from '@/components/Reports/UserReport.vue';
import AllCoursesReports from '@/components/Reports/AllCoursesReports.vue';
import CoursesReport from '@/components/Reports/CoursesReport.vue';
import SupportPage from '@/components/SupportPage.vue';
import ForgotPassword from '@/components/ForgotPasswordComponent.vue';
import ResetPasswordComponent from '@/components/ResetPasswordComponent.vue';
import AdminCategories from '@/components/Admin/AdminCategories.vue';
import CreateCategory from '@/components/Admin/CreateCategory.vue';
import EditCategory from '@/components/Admin/EditCategory.vue';
import UserSetupPassword from '@/components/UserSetupPassword.vue';
import BulkCreateUsers from '@/components/Admin/BulkCreateUsers.vue';
import VideoTest from '@/components/learner/VideoTest.vue';
import LmsInstances from '@/components/SuperAdmin/LMSInstances.vue';
import ViewInstance from '@/components/SuperAdmin/ViewInstance.vue';
import EditInstance from '@/components/SuperAdmin/EditInstance.vue';
import CreateSubscription from '@/components/SuperAdmin/CreateSubscription.vue';
import UpdateSubscription from '@/components/SuperAdmin/EditSubscription.vue';
import CreateInstanceUser from '@/components/SuperAdmin/CreateInstanceUser.vue';
import EditInstanceUser from '@/components/SuperAdmin/EditInstanceUser.vue';
import CreateInstance from '@/components/SuperAdmin/CreateLmsInstance.vue';
import LoginRedirect from '@/components/LoginRedirect.vue';

export default [
  {
    path: '/login-redirect',
    name: 'LoginRedirect',
    component: LoginRedirect,
    meta: { title: 'Redirecting | Jam LMS', requiresAuth: false }
  },  
  {
    path: '/admin/instances',
    name: 'LmsInstances',
    component: LmsInstances,
    meta: { title: 'Manage LMS Instances | Jam LMS', requiresAuth: true, roles: ['super_admin'] }
  },  
  {
    path: '/instances/create',
    name: 'CreateInstance',
    component: CreateInstance,
    meta: { title: 'Create LMS Instances | Jam LMS', requiresAuth: true, roles: ['super_admin'] }
  },
  {
    path: '/admin/instance/:instance_id/subscriptions/create',
    name: 'CreateSubscription',
    component: CreateSubscription,
    meta: { title: 'Create LMS Instance | Jam LMS', requiresAuth: true, roles: ['super_admin'] },
    props: true, // ✅ Pass instance_id automatically as a prop
  },
  {
    path: '/admin/instance/:instance_id/subscriptions/:id/edit',
    name: 'EditSubscription',
    component: UpdateSubscription,
    meta: { title: 'Update Subscription | Jam LMS', requiresAuth: true, roles: ['super_admin'] },
    props: true,
  },
  {
    path: '/admin/instance/:id',
    name: 'ViewInstance',
    component: ViewInstance,
    meta: { title: 'View LMS Instance | Jam LMS', requiresAuth: true, roles: ['super_admin'] }
  },
  {
    path: '/admin/instance/:id/edit',
    name: 'EditInstance',
    component: EditInstance,
    meta: { title: 'Edit LMS Instance | Jam LMS', requiresAuth: true, roles: ['super_admin'] }
  },
  {
    path: '/admin/instance/:instance_id/users/create',
    name: 'CreateInstanceUser',
    component: CreateInstanceUser,
    meta: { title: 'Create Instance User | Jam LMS', requiresAuth: true, roles: ['super_admin'] },
    props: true,
  },  
  {
    path: '/admin/instance/:instance_id/user/:user_id/edit',
    name: 'EditInstanceUser',
    component: EditInstanceUser,
    props: true,
    meta: { title: 'Edit Instance User | Jam LMS', requiresAuth: true, roles: ['super_admin'] },
  },  
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardComponent,
    meta: { title: 'Admin Dashboard | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin', 'instructor', 'manager'] }
  },
  {
    path: '/courses',
    name: 'Courses',
    component: CoursesTable,
    meta: { title: 'Manage Courses | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin', 'instructor'] }
  },
  {
    path: '/addcourse',
    name: 'Add Courses',
    component: AddCourse,
    meta: { title: 'Add New Course | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin', 'instructor'] }
  },
  {
    path: '/courses/:id/edit',
    name: 'EditCourse',
    component: EditCourse,
    meta: { title: 'Edit Course | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin', 'instructor'] }
  },
  {
    path: '/adduser',
    name: 'CreateUser',
    component: CreateUser,
    meta: { title: 'Add Users | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin', 'instructor'] }
  },
  {
    path: '/bulkcreateusers',
    name: 'BulkCreateUsers',
    component: BulkCreateUsers,
    meta: { title: 'Bulk Create Users | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin'] }
  },
  {
    path: '/edituser/:id', // :id to capture user ID
    name: 'EditUser',
    component: EditUser,
    meta: { title: 'Edit Users | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin', 'instructor'] }
    },  
    {
      path: '/user/:id', // :id to capture user ID
      name: 'ViewUser',
      component: ViewUser,
      meta: { title: 'View User | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin', 'instructor'] }
      },  
  {
    path: '/users',
    name: 'AdminUsers',
    component: AdminUsers,
    meta: { title: 'Manage Users | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin', 'instructor'] }
  },
  {
    path: '/groups',
    name: 'UserGroups',
    component: UserGroups,
    meta: { title: 'Manage Groups | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin', 'instructor'] }
  },
  {
    path: '/groups/create',
    name: 'CreateGroup',
    component: CreateGroup,
    meta: { title: 'Create Group | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin', 'instructor'] }
  },
  {
    path: '/groups/:id',
    name: 'ViewGroup',
    component: ViewGroup,
    meta: { title: 'View Group | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin', 'instructor'] }
  },
  {
    path: '/groups/:id/edit',
    name: 'EditGroup',
    component: EditGroup,
    meta: { title: 'Edit Groups | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin', 'instructor'] }
  },
  {
    path: '/branches',
    name: 'AdminBranches',
    component: AdminBranches,
    meta: { title: 'Manage Branches | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin'] }
  },
  {
    path: '/branches/create',
    name: 'CreateBranch',
    component: CreateBranch,
    meta: { title: 'Create Branch | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin'] }
  },
  {
    path: '/branches/:id',
    name: 'ViewBranch',
    component: ViewBranch,
    meta: { title: 'View Branch | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin'] }
  },
  {
    path: '/branches/:id/edit',
    name: 'EditBranch',
    component: EditBranch,
    meta: { title: 'Edit Branch | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin'] }
  },
  {
    path: '/categories',
    name: 'AdminCategories',
    component: AdminCategories,
    meta: { title: 'Manage Categories | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin'] }
  },
  {
    path: '/categories/create',
    name: 'CreateCategory',
    component: CreateCategory,
    meta: { title: 'Create Category | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin'] }
  },
  {
    path: '/categories/:id/edit/',
    name: 'EditCategory',
    component: EditCategory,
    meta: { title: 'Edit Category | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin'] }
  },
  {
    path: '/reports/users',
    name: 'AllUsersReports',
    component: AllUsersReports,
    meta: { title: 'User Reports | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin', 'manager'] }
  },
  {
    path: '/reports/users/:id',
    name: 'UserReport',
    component: UserReport,
    meta: { title: 'User Report | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin', 'manager'] }
  },
  {
    path: '/reports/courses',
    name: 'AllCoursesReports',
    component: AllCoursesReports,
    meta: { title: 'Course Reports | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin', 'manager'] }
  },
  {
    path: '/reports/courses/:id',
    name: 'CoursesReport',
    component: CoursesReport,
    meta: { title: 'Course Report | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin', 'manager'] }
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginComponent,
    meta: { title: 'Login to Jam LMS', requiresAuth: false }
  },
  {
    path: '/logout',
    name: 'Logout',
    component: LogoutButton,
    meta: { requiresAuth: true }
  },
  {
    path: '/videotest',
    name: 'VideoTest',
    component: VideoTest,
    meta: { requiresAuth: false }
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterComponent,
    meta: { requiresAuth: true, roles: ['super_admin'] }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: { title: 'Forgot Password | Jam LMS', requiresAuth: false }
  },
  {
    path: '/password-reset',
    name: 'PasswordReset',
    component: ResetPasswordComponent,
    meta: { title: 'Reset Password | Jam LMS', requiresAuth: false }
  },
  {
    path: "/set-password",
    name: "UserSetupPassword",
    component: UserSetupPassword,
    meta: { title: 'Set Password | Jam LMS', requiresAuth: false }
  },  
  {
    path: '/support',
    name: 'Support',
    component: SupportPage,
    meta: { title: 'Support | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin', 'instructor', 'learner', 'manager'] }
  },
  // Learner-specific routes
  {
    path: '/learner/dashboard',
    name: 'Learner Dashboard',
    component: LearnerDashboard,
    meta: { title: 'Dashboard | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin', 'instructor', 'learner', 'manager'] }
  },
  {
    path: '/learner/courses',
    name: 'My Courses',
    component: MyCourses,
    meta: { title: 'Courses | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin', 'instructor', 'learner', 'manager'] }
  },
  {
    path: '/learner/progress',
    name: 'My Progress',
    component: MyProgress,
    meta: { title: 'Progress | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin', 'instructor', 'learner', 'manager'] }
  },
  {
    path: '/learner/badges',
    name: 'My Badges',
    component: MyBadges,
    meta: { title: 'Badges | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin', 'instructor', 'learner', 'manager'] }
  },
  {
    path: '/learner/course-catalog',
    name: 'Course Catalog',
    component: CourseCatalog,
    meta: { title: 'Course Catlog | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin', 'instructor', 'learner', 'manager'] }
  },
  {
    path: '/learner/catalog/course/:id', // Dynamic route for viewing a specific course
    name: 'ViewCourse',
    component: ViewCourse,
    props: true, // Allows route parameters to be passed as props to the component
    meta: { title: (route) => `${route.params.courseName || 'Course'} | Jam LMS`, requiresAuth: true, roles: ['super_admin', 'admin', 'instructor', 'learner', 'manager'] } // Ensure the user is authenticated and is a learner
  },
  {
    path: '/learner/course/:course/unit/:unit_order?',
    name: 'course',
    component: CoursePage,
    props: true, 
    meta: { title: (route) => `${route.params.courseName || 'Course'} | Jam LMS`, requiresAuth: true, roles: ['super_admin', 'admin', 'instructor', 'learner', 'manager'] } 
  },
  {
    path: '/learner/certificates',
    name: 'User Certificates',
    component: UserCertificates,
    meta: { title: 'Certificates | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin', 'instructor', 'learner', 'manager'] }
  },
  {
    path: '/profile',
    name: 'User Profile',
    component: MyProfile,
    meta: { title: 'Profile | Jam LMS', requiresAuth: true, roles: ['super_admin', 'admin', 'instructor', 'learner', 'manager'] }
  },
];
